<template>
   <div class="dataTables_wrapper no-footer mtable">
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <div class="btn-group p-0 pull-left mtable-tool-fn">
        <div class="btn btn-default" :class="{'radius-r':!handle.delete}" @click="addRole">
          <i class="glyphicon glyphicon-new-window tab-he-glyphicon"></i>{{multiLanguage.addRole}}
        </div>
        <div class="btn btn-default btn-danger mtable-tool-delete" :class="{'radius-r':handle.delete}" v-show="handle.delete && !deleteCol.switch" @click="deleteCol.switch = true">
          <i class="glyphicon glyphicon-trash tab-he-glyphicon"></i>
          {{multiLanguage.deleteRole}}
        </div>
        <div class="btn btn-default btn-danger mtable-tool-delete" :class="{'radius-r':handle.delete}" v-show="handle.delete && deleteCol.switch" @click="deleteColNotarizeFn">
          <i class="glyphicon glyphicon-log-out tab-he-glyphicon"></i>
          {{multiLanguage.confirmDelete}}
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="datatable-scroll">
      <slot name="datatable-scroll">
      </slot>
      <table class="table table-bordered table-hover datatable-highlight dataTable no-footer" id="DataTables_Table_2" role="grid" aria-describedby="DataTables_Table_2_info">
        <thead>
          <tr role="row">
            <th v-for="(item,index) in thData">{{item}}</th>
            <th v-if="handle" tabindex="0" >{{multiLanguage.th.operation}}</th>
          </tr>
        </thead>
        <tbody  :class="{'deleteCol-opt': handle.delete}">
          <tr role="row" v-show="trData.length > 0" v-for="(item,index) in trData" @click="clickColFn(item, index)" :class="trCls && trCls(item, index)">
            <td class="sorting_1" v-for="key in trDataKeys" @click="deletePitch(item)">{{item[key]}}</td>
            <td v-if="handle" class="text-center pointer" :class="{'pointer': deleteCol.switch}" @click="linkRegister(item)">
               <i v-show="!deleteCol.switch" class="icon-compose"></i>
              <i v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1" class="glyphicon glyphicon-ok color-red"></i>
              <i v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1" class="glyphicon glyphicon-trash tab-he-glyphicon"></i>
            </td>
          </tr>
          <tr v-if="trData.length > 0 && Object.keys(totalTr).length > 0">
            <td v-for="item in totalTr">{{item}}</td>
          </tr>
        </tbody>
      </table>
      <noData v-if="trData.length==0" :text="multiLanguage.nodata" :fontSize="'18'"></noData>
    </div>
    <div class="datatable-footer">
    </div>
    <RoleDialog ref="RoleDialog" @addRefresh="addRefresh"/>
  </div>
</template>

<script>
  import RoleDialog from "./add-role-dialog.vue";
  import noData from "components/noData"
  import fileUpload from "vue-upload-component"
  import { Dropdown, Pagination } from "uiv"
  import { mapMutations } from "vuex"
import  {URL_FINDALLPRIVILEGE } from '../api/api.js'
  export default {
    props: {
      thData: {  // 表格th数据
        type: Array,
        default: []
      },
      trData: {
      },  // 表格tr数据
      totalData: {
        default: false
      },
      handle: {
        default: false
      },
      multiLanguage: {  // 翻译，也是文字型数据
        type: Object,
        default: {}
      },
      trCls: {  // tr class
        default: false
      }
    },
    data () {
      return {
        deleteCol: {  // 删除功能
          switch: false,
          list: []
        },
        totalTr: {}
      }
    },
    mounted () {
    },
    computed: {
      trDataKeys () {
        return Object.keys(this.trData[0])
      }
    },
    methods: {
      addRole(){
        //TODO 打开弹框
        this.$refs["RoleDialog"].open(this.trData);
      },
      addRefresh(){
          this.$emit("addRefresh")
      },
       deletePitch (item) {
        if (this.deleteCol.switch === false) {
          return
        }
        let id = item[this.handle.idKey]
        let index = this.deleteCol.list.indexOf(id)
        if (index === -1) {
          this.deleteCol.list.push(id)
        } else {
          this.deleteCol.list.splice(index, 1)
        }
      },
      deleteColNotarizeFn () {
        this.deleteCol.switch = false
        this.$emit("deleteList", this.deleteCol.list)
        this.deleteCol.list = []
      },
      clickColFn (colItem, index) {
        this.$emit("clickCol", colItem, index)
      },
      linkRegister (item) {
        if (this.deleteCol.switch === true) {
            this.deletePitch(item)
            return;
          }
          this.$http.post(URL_FINDALLPRIVILEGE, {"role": item.Role_ID}).then((res) => {
            if(res.data.data){
              let data = res.data.data;
              let _temp_list = [];
              data.forEach(item => {
                _temp_list.push(`${item.right_id}\$${item.entity}`)
              });
            this.$router.push({
              path: this.handle.link,
              query: {
                Role_ID: item[this.handle.idKey],
                data:_temp_list
              }
            })
            }
          })

      },
      ...mapMutations(["SAVEPAGEMAXINDEX"])
    },
    watch: {
    },
    components: {
      fileUpload,
      Dropdown,
      noData,RoleDialog
    }
  }
</script>

<style lang="scss" type="text/scss" >
  .mtable{
    .datatable-scroll{
      .table{
        thead{
          border-top: 1px solid #ddd;
        }
      }
    }
    .mtable-tool{
      padding: 0 20px 25px;
      border-bottom: 0;
      .mtable-tool-seek,.mtable-tool-selPage,.mtable-tool-fn {
        padding-top: 20px;
        line-height: 36px;
      }
      .mtable-tool-fn {
        .radius-r{
          border-top-right-radius: 3px !important;
          border-bottom-right-radius: 3px !important;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// authTable.vue?23253834